import React from 'react';
import { useTranslation } from 'react-i18next';
import './MasteryBadge.scss';


export const MasteryBadge: React.FC<{ status: string }> = ({ 
  status,
}) => {
  const { t } = useTranslation();

  return (
    <div className={`skill-mastery group-row-${status}`}>
      <span className="skill-mastery-dot" />
      {t(status, { ns: "common" })}
    </div>
  );
};